import { getAuth, onAuthStateChanged } from "firebase/auth";
export const URL = "https://us-central1-techmicro-usa-admin.cloudfunctions.net";
// export const URL = "https://5584-2407-d000-11-3680-1887-4642-a783-81f6.ngrok-free.app/techmicro-stage/us-central1/"
export const getHeaders = async () => {
    try {
        const auth = getAuth();
        const user = await new Promise((resolve) => {
            const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
                unsubscribe();
                resolve(firebaseUser);
            });
        });
        if (!user) {
            console.warn("⚠️ No user logged in — returning empty headers");
            return {};
        }
        const token = await user.getIdToken();
        return {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        };
    } catch (err) {
        return {
            "Content-Type": "application/json",
            Accept: "application/json",
        };
    }
};
